export default __webpack_public_path__ + "static/media/admin-record-bg.87295c7f.png";